/**
 * Sqft products (pavers, clay tiles) with the overage dropdown. See docs/dev/docs-product-overage.md
 * Visible input = entered sqft; min/max and Add to Cart enable stay with quantity-input (global.js).
 * Hidden `quantity` = ceil(entered × (100 + overage%) / 100), and the Add to Cart price uses that total.
 */
if (!customElements.get('sqft-overage')) {
  customElements.define(
    'sqft-overage',
    class SqftOverage extends HTMLElement {
      connectedCallback() {
        this.enteredInput = this.querySelector('[data-overage-entered]')
        this.qtyInput = this.querySelector('[data-overage-qty]')
        this.totalEl = this.querySelector('[data-overage-total]')
        this.overageSelect = this.querySelector('[data-overage-select]')
        this.atcButton =
          this.closest('product-info')?.querySelector(
            '.product-form__submit'
          ) || document.querySelector('.product-form__submit')

        this.recalculate = this.recalculate.bind(this)
        this.scheduleRecalculate = this.scheduleRecalculate.bind(this)

        this.enteredInput?.addEventListener('input', this.scheduleRecalculate)
        this.enteredInput?.addEventListener('change', this.scheduleRecalculate)
        this.addEventListener('overage:change', this.scheduleRecalculate)

        this.unsubscribers = []
        if (
          typeof subscribe === 'function' &&
          typeof PUB_SUB_EVENTS !== 'undefined'
        ) {
          this.unsubscribers.push(
            subscribe(PUB_SUB_EVENTS.quantityUpdate, this.scheduleRecalculate),
            subscribe(PUB_SUB_EVENTS.variantChange, this.scheduleRecalculate)
          )
        }

        this.scheduleRecalculate()
      }

      disconnectedCallback() {
        this.enteredInput?.removeEventListener(
          'input',
          this.scheduleRecalculate
        )
        this.enteredInput?.removeEventListener(
          'change',
          this.scheduleRecalculate
        )
        this.removeEventListener('overage:change', this.scheduleRecalculate)
        this.unsubscribers?.forEach((unsubscribe) => unsubscribe?.())
      }

      // quantity-input rewrites the Add to Cart price from the visible input on the same events, so run after it.
      scheduleRecalculate() {
        setTimeout(this.recalculate, 0)
      }

      overagePercent() {
        const value = parseFloat(this.overageSelect?.value)
        return Number.isFinite(value) && value > 0 ? value : 0
      }

      recalculate() {
        const entered = parseFloat(this.enteredInput?.value)
        const min = parseFloat(this.enteredInput?.dataset.min)
        const max = parseFloat(this.enteredInput?.dataset.max)
        const inRange =
          Number.isFinite(entered) &&
          entered > 0 &&
          !(Number.isFinite(min) && entered < min) &&
          !(Number.isFinite(max) && entered > max)

        const total = inRange
          ? Math.ceil((entered * (100 + this.overagePercent())) / 100)
          : 0

        if (this.qtyInput) this.qtyInput.value = String(Math.max(1, total))
        if (this.totalEl) this.totalEl.textContent = total ? String(total) : '—'
        this.writeOrderTotal(total)
        if (total) this.updateAtcPrice(total)
      }

      writeOrderTotal(totalSqft) {
        const root = this.closest('product-info') || document
        if (typeof window.setPdpHostTotal !== 'function') return
        const unitCents = parseFloat(
          root
            .querySelector('[id^="price-"] .price-item--regular[data-price]')
            ?.getAttribute('data-price')
        )
        if (!totalSqft || !Number.isFinite(unitCents)) {
          window.setPdpHostTotal(root, null)
          return
        }
        window.setPdpHostTotal(root, Math.round(unitCents * totalSqft))
      }

      updateAtcPrice(total) {
        const price = this.atcButton?.querySelector('.price-item--regular')
        const unitCents = price?.getAttribute('data-price')
        if (!price || unitCents == null || unitCents === '') return
        const dollars = ((parseFloat(unitCents) * total) / 100)
          .toFixed(2)
          .replace(/\.?0+$/, '')
        price.textContent = `$${dollars}`
      }
    }
  )
}
